/**
 * Waypoints Library
 * Loaded conditionally via pattern requirements or ACF theme options
 *
 * @requires waypoints
 */

import 'waypoints/lib/jquery.waypoints.min';
import 'waypoints/lib/shortcuts/inview.min';

// Expose Waypoint globally for patterns and inline scripts
if (typeof window !== 'undefined') {
  window.Waypoint = window.Waypoint || {};
}
